// store/themeSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type Theme = 'light' | 'dark' | 'system';

export interface ThemeState {
    theme: Theme;
    appliedTheme: 'light' | 'dark';
}

// Load saved theme, default to system

export const getSystemTheme = (): 'light' | 'dark' => {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};

export const initialThemeState: ThemeState = {
    theme: 'dark',
    appliedTheme: 'dark'
};

const themeSlice = createSlice({
    name: 'theme',
    initialState: initialThemeState,
    reducers: {
        setTheme(state, action: PayloadAction<Theme>) {
            state.theme = action.payload;
        },
        setAppliedTheme(state, action: PayloadAction<'light' | 'dark'>) {
            state.appliedTheme = action.payload;
        },
        toggleTheme(state) {
            let newTheme: Theme;
            if (state.theme === 'light') newTheme = 'dark';
            else if (state.theme === 'dark') newTheme = 'light';
            else newTheme = getSystemTheme() === 'light' ? 'dark' : 'light';
            state.theme = newTheme;
        }
    }
});

export const { setTheme, setAppliedTheme, toggleTheme } = themeSlice.actions;
export const selectTheme = (state: { theme: ThemeState }) => state.theme.theme;
export const selectAppliedTheme = (state: { theme: ThemeState }) => state.theme.appliedTheme;

export default themeSlice.reducer;
